module.exports = __webpack_public_path__ + "img/ic_zhjx_teacher.292b6d5e.png";